import { useEffect, useState } from "react";
import QRCode from "qrcode";

/** Gera o QR no browser a partir do payload (Pix copia e cola, otpauth). */
export function QrImage({ value, alt, size = 220 }: { value: string; alt: string; size?: number }) {
  const [src, setSrc] = useState<string | null>(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    let alive = true;
    setSrc(null);
    setErr(false);
    QRCode.toDataURL(value, { margin: 0, width: size * 2, errorCorrectionLevel: "M", color: { dark: "#1E1A17", light: "#FFFFFF" } })
      .then((u) => alive && setSrc(u))
      .catch(() => alive && setErr(true));
    return () => {
      alive = false;
    };
  }, [value, size]);
  return (
    <div className="qrbox" role="img" aria-label={alt}>
      {src ? <img src={src} alt="" width={size} height={size} style={{ width: size, height: size }} /> : <div style={{ width: size, height: size, display: "grid", placeItems: "center", color: "#857C74", fontSize: 12 }}>{err ? "QR indisponível" : "…"}</div>}
    </div>
  );
}
